export default {
  HIOPOSWEBSERVICES: 'http://localhost:8000',
  HIOPOSREPORTS: 'https://hioposreports-dev.saas.com.co',
}
